import { defineCustomElements, setAssetPath } from './dist/components/index'; // eslint-disable-line

setAssetPath(window.componentLibraryPath || '/');
defineCustomElements();
